/**
 * Models for the Shift Planning page (page-specific only)
 * 
 * Shared types (ShiftType, PlanType, etc.) live in src/types/shiftPlan.ts
 */
import { PlanType, ShiftType, GetAllShiftPlansRequest } from "../../types/shiftPlan";

/**
 * Option for shift selection dropdown
 */
export interface ShiftOption {
  value: string;
  label: string;
}

/**
 * Option for tab selection
 */
export interface TabOption {
  value: string;
  label: string;
}

/**
 * Data structure for shift plan
 */
export interface ShiftPlanData {
  date?: string;
  shift?: string;
  selectedDate?: string;
  selectedShift?: string;
  selectedTab?: string;
  isGenerated?: boolean;
}

/**
 * Request for generating a shift plan
 */
export interface GenerateShiftPlanRequest {
  date: string;
  shift?: string;
  shiftType?: string;
  tabType?: string;
  planType?: PlanType;
}

/**
 * Response from generating a shift plan
 */
export interface GenerateShiftPlanResponse {
  success?: boolean;
  isSuccessful?: boolean;
  planId?: string;
  message?: string;
}

/**
 * Props for ShiftPlanning component
 */
export interface ShiftPlanningProps {
  shiftOptions?: ShiftOption[];
  tabOptions?: TabOption[];
  defaultTab?: string;
  onDateChange?: (date: string) => void;
  onShiftChange?: (shift: string) => void;
  onTabChange?: (tab: string) => void;
}

/**
 * Default tab options
 */
export const defaultTabOptions: TabOption[] = [
  { value: "prior-day", label: "Prior Day (PDP)" },
  { value: "start-of-shift", label: "Start of Shift (SOS)" },
];

/**
 * Get current date in YYYY-MM-DD format
 */
export function getTodayDate(): string {
  const date = new Date();
  return date.toISOString().split("T")[0];
}

export function getYesterdayDate(): string {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return date.toISOString().split("T")[0];
}

export const getFutureDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  return date.toISOString().split("T")[0];
};

export const buildGetAllShiftPlansRequest = (
  nodeId: string,
  date: string,
  shiftType: ShiftType,
  queryDevPlanVersions?: boolean,
  planType?: PlanType
): GetAllShiftPlansRequest => {
  return {
    nodeId,
    warehouseId: nodeId,
    date,
    shiftType,
    queryDevPlanVersions,
    planType,
  };
};
